import { render, staticRenderFns } from "./Fund-chartLoad.vue?vue&type=template&id=20d9cce8&scoped=true&"
import script from "./Fund-chartLoad.vue?vue&type=script&lang=js&"
export * from "./Fund-chartLoad.vue?vue&type=script&lang=js&"
import style0 from "./Fund-chartLoad.vue?vue&type=style&index=0&id=20d9cce8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d9cce8",
  null
  
)

export default component.exports